import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useTokenManagement } from "@/hooks/useTokenManagement";
import { Message } from "@/types/chat";

export function useCaseCreation() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isCreatingCase, setIsCreatingCase] = useState(false);
  const [progress, setProgress] = useState(0);
  const { checkTokens, recordTokenUsage } = useTokenManagement();

  const handleCreateCase = async (messages: Message[]) => {
    setIsCreatingCase(true);
    setProgress(0);
    
    const hasTokens = await checkTokens('case-creation', 'case-creation');
    if (!hasTokens) {
      setIsCreatingCase(false);
      return;
    }

    try {
      const conversationSummary = messages.map(m => m.content).join('\n\n');
      
      setProgress(50);
      const { data, error } = await supabase.functions.invoke('generate-workflow', {
        body: {
          title: "Ny sak fra AI-assistent",
          description: conversationSummary,
        }
      });

      if (error) throw error;

      setProgress(75);
      await recordTokenUsage('case-creation', 'case-creation');

      toast({
        title: "Sak opprettet",
        description: "Saken er nå tilgjengelig i saksoversikten"
      });

      setProgress(100);
      navigate('/cases');
    } catch (error) {
      console.error('Error creating case:', error);
      toast({
        variant: "destructive",
        title: "Feil ved saksopprettelse",
        description: "Kunne ikke opprette saken. Vennligst prøv igjen senere."
      });
    } finally {
      setIsCreatingCase(false);
      setProgress(0);
    }
  };

  return {
    isCreatingCase,
    progress,
    handleCreateCase
  };
}